import {TContinent, TRegion, TState} from "../types";

/**
 * Get all country IDs from a continent
 */
export const getCountryIdsFromContinent = (continent: TContinent): number[] =>
	continent?.countries?.map((c) => c.id) || [];

/**
 * Get all state IDs from a region
 */
export const getStateIdsFromRegion = (region: TRegion): number[] =>
	region?.states?.map((s) => s.id) || [];

/**
 * Get all city IDs from a state
 */
export const getCityIdsFromState = (state: TState): number[] =>
	state?.cities?.map((c) => c.id) || [];
